import React, { useState } from "react";
import { isEmpty } from "lodash";
import { AddToLinkButton } from "../../../../../../../components";
import { type FlowEndInfo } from "../../../types";
import NextLinkCard from "./nextLinkCard/NextLinkCard";
import NextLinkModal from "./nextLinkModal/NextLinkModal";

import styles from "./nextLink.module.scss";

interface NextLinkProps {
  isReadOnly: boolean;
  flowEndInfo: FlowEndInfo;
  onFlowEndChange: (flowEnd: FlowEndInfo) => void;
}

const NextLink: React.FC<NextLinkProps> = ({ isReadOnly, flowEndInfo, onFlowEndChange }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { nextLinkUrl = "", nextLinkLabel = "" } = flowEndInfo;

  const handleSave = (url: string, displayName: string) => {
    onFlowEndChange({
      ...flowEndInfo,
      nextLinkUrl: url,
      nextLinkLabel: displayName,
    });
  };

  return (
    <div className={styles.root}>
      <div className={styles.body}>
        {isEmpty(nextLinkUrl) ? (
          <AddToLinkButton isDisabled={isReadOnly} text="External Link" onClick={() => setIsModalOpen(true)} />
        ) : (
          <NextLinkCard
            url={nextLinkUrl || ""}
            displayName={nextLinkLabel || ""}
            isReadOnly={isReadOnly}
            onChange={() => setIsModalOpen(true)}
          />
        )}
      </div>
      <NextLinkModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSave={handleSave}
        initialValue={nextLinkUrl || ""}
        initialDisplayName={nextLinkLabel || ""}
      />
    </div>
  );
};

export default NextLink;
